import { el } from "@dhx/ts-common/dom";
import locale from "./locales/en";

export function selectAllView() {
	return el(".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all", locale.selectAll);
}

export function unselectAllView() {
	return el(".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all", locale.unselectAll);
}

export function emptyListView() {
	return el("ul.dhx_list", [
		el("li.dhx_list-item.dhx_combobox-options__item", {
		}, locale.notFound)
	]);
}